import config from '@fmm/hostname-env';
import development from './config/development';
import test from './config/test';
import staging from './config/staging';
import production from './config/production';

config.add(development, test, staging, production);
config.init(window.location.hostname);
export default config;
